import React from 'react'

const headerImg = require('../../assets/img/header-img.svg')

const HeaderImg = () => (
  <div className="column header-img is-hidden-mobile">
    <img src={headerImg} />
  </div>
)

const Header = () => (
  <section className="bg-gray" id="top">
    <div className="container">
      <div className="columns">
        <div className="column header-content">
          <h1 className="text-green">Monitor, track and analyze your grow from wherever you are with Farmhand.</h1>
          <button
            id="gs-top"
            className="button is-medium is-primary"
            onClick={() => {
              window.scrollTo(0, document.body.scrollHeight)
            }}
          >get started</button>
        </div>
        <div className="column is-hidden-tablet mobile-header-img">
          <img src={headerImg} />
        </div>
        <HeaderImg />
      </div>
    </div>
  </section>
)

export default Header



// WEBPACK FOOTER //
// ./containers/Header.js